import { upstreamProviderSource } from "@songtradr-sso/shared/common";

export const staticText = {
  mfa: {
    sms: {
      verify: {
        title: "We've sent a code to your phone",
        description:
          "We texted a unique code to +XXXXXXX{finalDigits}. Please enter the code below.",
        inputLabel: "Enter your verification code",
        finalDigitsPlaceholder: "XXXX",
        rememberMe: "Remember this device for 90 days",
        button: "Verify",
      },
    },
    totp: {
      verify: {
        title: "Enter the code from your authenticator app",
        description:
          "Please enter your verification code from the Google Authenticator app below.",
        inputLabel: "Enter your verification code",
        rememberMe: "Remember this device for 90 days",
        button: "Verify",
      },
    },
  },
  workspaceCapture: {
    title: "Enter your workspace name",
    button: "Continue",
    alerts: { error: "We couldn't find that workspace." },
    links: {
      defaultSignIn: {
        text: "Are you an artist, a rights holder or a music partner?",
        trigger: "Sign in here.",
      },
      helpPanel: {
        text: "Need help finding your workspace name?",
        trigger: "Find out more.",
      },
    },
    helpPanel: {
      title: "Find your workspace domain",
      description:
        "Follow this quick guide to access your organisation’s personalised login page.",
      tips: [
        "Your workspace domain is usually the name of your company or organisation.",
        "Only type lowercase letters, numbers, hyphens(-), or underscores(_). No spaces or other special characters.",
        "If your company has child organisations, use the parent company domain to log in.",
        "Ask a colleague if you’re unsure, or check any company login emails/links.",
      ],
      info: "Once entered, you'll reach your branded login page and can bookmark it for future logins.",
      noWorkspace: "Don't have a workspace? Click here.",
      tempLookingForStudio: "Looking for Songtradr Studio login? Click here.",
    },
  },
  authButtons: {
    title: "Sign in to your account",
    noMethods:
      "No login methods available. Please contact your workspace administrator.",
    email: "Continue with Email",
    providers: {
      [upstreamProviderSource.enum.CUSTOM]: "Continue with your provider",
      [upstreamProviderSource.enum.GOOGLE]: "Continue with Google",
      [upstreamProviderSource.enum.MICROSOFT]: "Continue with Microsoft",
    },
  },
  emailSignIn: {
    title: "Sign in to your account",
    buttons: {
      submit: "Sign in",
      signUp: "Don't have an account?",
      recovery: "Forgot password?",
    },
    alerts: {
      signUpSuccess: "You have successfully signed up",
    },
  },
  emailSignUp: {
    title: "Create an account",
    buttons: {
      submit: "Sign up",
      signIn: "Already have an account?",
    },
    legals: {
      signature: "By signing up I agree to the ",
      cookiePolicy: "Cookie Policy",
      privacyPolicy: "Privacy Policy",
      terms: "Terms of Use",
      and: "and",
    },
  },
  emailConfirmation: {
    title: "Verify your email",
    description:
      "If your sign up credentials were valid, you will receive an email containing a verification code",
    inputLabel: "Enter your verification code",
    buttons: {
      submit: "Verify",
      resend: "Resend email",
    },
    emailError: "Lost sign up session. Please try again.",
  },
  accountRecovery: {
    forgotPassword: {
      title: "Forgot Password?",
      description:
        "Provide the email linked to your account, and we'll send you a code for resetting your password.",
      inputLabel: "Enter your email address",
      button: "Send Reset Link",
    },
    verifyCode: {
      title: "We've sent your code via email",
      description:
        "Input the verification code we've sent, then select a new password for your account.",
      inputLabel: "Enter your verification code",
      button: "Set new password",
      emailError:
        "Email data has been lost. Please go back and restart the forgot password process.",
    },
  },
  pageContainer: {
    copyright: "Copyright © {year} MassiveMusic. All rights reserved.",
    changeWorkspace: "Change Workspace",
  },
} as const;
